import React, { useContext, useState } from 'react'
import Sidebar from '../Sidebar'
import { addcontext } from '../../ContextShare/ContextShare'
import klaimage from '../../Assets/kla-logo.png'
import TableConstituency from '../Constituency/TableConstituency'
import { Icon } from '@iconify/react/dist/iconify.js'
import TableConstituencyMapping from '../Constituency/TableConstituencyMapping'
import FlowChart from '../FlowChart'

function DocumentR() {
    const { addConstituency, setaddConstituency } = useContext(addcontext)
    const {isSidebarCloses,setIsSidebarCloses}=useContext(addcontext)
    const [flowChartOpen,setFlowChartOpen]=useState(true)
    const handleConstituency = () => {
        setaddConstituency(!addConstituency)
    }
    return (
        <>
            <div className='flex w-full h-full ' style={{ fontFamily: 'ropa sans' }}>
                <div className='flex flex-col w-full h-full'>

                    <div className='w-full h-24 flex flex-row justify-between bg-success rounded border ' style={{height:'13vh'}}>
                        {/* logo */}
                        <div className='w-2/12 flex items-center'>
                            <img src={klaimage} className='w-6/12 ms-12 lg:flex hidden p-1' alt="" /></div>

                            <div className='flex items-center' onClick={()=>setIsSidebarCloses(!isSidebarCloses)}>
                            <Icon icon="teenyicons:expand-solid" className='text-2xl font-bold  cursor-pointer'/>
                            </div>

                        {/* navigation bar */}
                        <div className='w-10/12 flex flex-row justify-center pr-5 items-center '>
                       <div className='flex flex-row bg-white rounded-xl border shadow text-lg font-bold'>
                       <div onClick={()=>setFlowChartOpen(true)} className={`cursor-pointer border-b-4 hover:border-blue-500 border-white px-8 pt-2 pb-1 rounded-s-xl text-blue-500 transform duration-100 ease-in-out ${flowChartOpen&&'bg-blue-100 text-blue-700 border-blue-100'}`}><button className=''>Flow chart</button></div>
                       <div className=' w-0.5 bg-gray-400 rounded'></div>
                       <div onClick={()=>setFlowChartOpen(false)} className={`cursor-pointer border-b-4 hover:border-blue-500 border-white px-8 pt-2 pb-1 rounded-e-xl text-blue-500 transform duration-100 ease-in-out ${!flowChartOpen&&'bg-blue-100 text-blue-700 border-blue-100'}`}><button>Document</button></div>
                       </div>
                        </div>

                    </div>

                    <div className='flex flex-row'>

                    <div className={`${isSidebarCloses&&'hidden'} md:w-4/12 lg:w-3/12 xl:w-2/12`}>
                        <Sidebar />
                        </div>


                        {/* Table */}
                        <div className={`${isSidebarCloses?'w-full':'lg:w-9/12 xl:w-10/12 w-full'} overflow-y-scroll items-start flex`} style={{ height: '87vh' }}>
                           {flowChartOpen?<FlowChart height={'77vh'} width={'88vw'} bg={false} />
                           :
                           <div className="flex flex-col justify-center items-center w-full h-full p-4">
                           <h1 className="text-2xl font-bold mb-6">Documentation</h1>
                           <div className="w-full max-w-2xl">
                             <table className="min-w-full bg-white border border-gray-200">
                               <thead>
                                 <tr>
                                   <th className="py-2 px-4 border-b-2 border-gray-200 text-left">Title</th>
                                   <th className="py-2 px-4 border-b-2 border-gray-200 text-left">Description</th>
                                   <th className="py-2 px-4 border-b-2 border-gray-200 text-left">Action</th>
                                 </tr>
                               </thead>
                               <tbody>
                                 <tr>
                                   <td className="py-2 px-4 border-b border-gray-200">Document 1</td>
                                   <td className="py-2 px-4 border-b border-gray-200">A brief description of Document 1.</td>
                                   <td className="py-2 px-4 border-b border-gray-200">
                                     <a 
                                       href="https://drive.google.com/file/d/1I7aVZWyG8aZz52G5cCBzGKAcK5hKkdnH/view?usp=sharing" 
                                       className="bg-blue-500 hover:bg-blue-700 text-white font-semibold rounded px-4 py-2"
                                       target="_blank"
                                       rel="noopener noreferrer"
                                     >
                                       View Doc 1
                                     </a>
                                   </td>
                                 </tr>
                                 <tr>
                                   <td className="py-2 px-4 border-b border-gray-200">Document 2</td>
                                   <td className="py-2 px-4 border-b border-gray-200">A brief description of Document 2.</td>
                                   <td className="py-2 px-4 border-b border-gray-200">
                                     <a 
                                       href="https://docs.google.com/document/d/1HuSvI4jZNdfbvYBLlctshqEHqITTnVb6bsiWtpnp4oM/edit?usp=sharing" 
                                       className="bg-blue-500 hover:bg-blue-700 text-white font-semibold rounded px-4 py-2"
                                       target="_blank"
                                       rel="noopener noreferrer"
                                     >
                                       View Doc 2
                                     </a>
                                   </td>
                                 </tr>
                               </tbody>
                             </table>
                           </div>
                         </div>
                           }
                        </div>
                    </div>
                </div></div>
        </>
    )
}

export default DocumentR